import { Grid } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import { ConfigurationContext } from '../../../../context api/Configuration/ConfigurationContext'
import CustomInput from '../../../CustomInput'
import { CustomDate, CustomSelect } from '../../../CustomForm'

export default function EditLeaveRequestComp({ state, setState }) {
  const { leaveStatus, from, to } = state

  const data = [
    {
      label: 'Leave Status',
      value: leaveStatus,
      name: 'leaveStatus',
      type: 'SELECT',
      options: ['APPROVED', 'NOT APPROVED', 'REJECTED'],
    },
    { label: 'From', value: from, name: 'from', type: 'DATE' },
    { label: 'To', value: to, name: 'to', type: 'DATE' },
  ]
  //console.log(data)
  return (
    <Grid container>
      {data.map((item, index) => {
        return (
          <React.Fragment>
            {item.type === 'SELECT' && (
              <Grid item lg={4}>
                <CustomSelect
                  label={item.label}
                  button={item.button}
                  options={item.options}
                  value={item.value}
                  // handleChange={item.handleChange}
                  form={state}
                  setForm={setState}
                  formCheck={true}
                  name={item.name}
                  disabled={item.disabled}
                />
              </Grid>
            )}
            {item.type === 'DATE' && (
              <Grid item lg={4}>
                <CustomDate label={item.label} icon={item.icon} name={item.name} value={item.value} form={state} setForm={setState} />
              </Grid>
            )}
            {!item.type && (
              <Grid item lg={4}>
                <CustomInput
                  label={item.label}
                  icon={item.icon}
                  name={item.name}
                  value={item.value}
                  number={item.number ? true : false}
                  //   form={targetForm}
                  //   setForm={setTargetForm}
                  form={state}
                  setForm={setState}
                  formCheck={true}
                  type={item.type}
                />
              </Grid>
            )}
          </React.Fragment>
        )
      })}
    </Grid>
  )
}
